import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import logo from '../assets/logo.png';
import GlobalSearch from './GlobalSearch';
import './Header.css';

// Zkratky na formuláře v "+ Přidat nové". Stejné openTab parametry, jaké
// používají tlačítka "Nová …" v jednotlivých seznamech — aby se otevřel
// tentýž tab, ne druhý duplicitní.
const QUICK_CREATE = [
  { id: 'order-new', title: 'Nová objednávka', path: '/orders/new', component: 'OrderForm', label: 'Objednávka', icon: 'bi-cart-plus', permission: 'order.create' },
  { id: 'media-new', title: 'Nové médium', path: '/media/new', component: 'MediaForm', label: 'Médium', icon: 'bi-newspaper', permission: 'media.create' },
  { id: 'customer-new', title: 'Nová firma', path: '/customer/new', component: 'CustomerForm', label: 'Zákazník', icon: 'bi-building-add', permission: 'crm.create' },
];

// Zatím natvrdo — až bude hotové napojení na tabulku `notification`,
// nahradí se voláním /api/notifications.
const NOTIFIKACE = [
  { id: 1, text: 'Testovací notifikace' },
];

function Header({ onLogout, onLogoClick, openTab, user, can = () => true }) {
  const fullName = `${user?.first_name || ''} ${user?.last_name || ''}`.trim();
  const displayName = fullName || user?.email || 'Uživatel';
  const quickCreate = QUICK_CREATE.filter((item) => can(item.permission));
  const canSettings = can('settings.manage');
  // Zvoneček se rozbaluje najetím myší, ne klikem — proto řízený `show`.
  const [notifikaceOtevrene, setNotifikaceOtevrene] = useState(false);

  return (
    <header className="app-header">
      <div className="d-flex align-items-center gap-3 flex-grow-1">
        <div className="d-flex align-items-center gap-2">
          <div onClick={onLogoClick} className="logo-link" style={{ cursor: 'pointer' }}>
            <img src={logo} alt="RV System" height="28" className="me-3" />
          </div>
        </div>
        <div className="d-none d-md-block" style={{ flex: 1, maxWidth: 480 }}>
          <GlobalSearch openTab={openTab} />
        </div>
      </div>

      <div className="d-flex align-items-center gap-3">
        {quickCreate.length > 0 && (
        <Dropdown align="end">
          <Dropdown.Toggle variant="outline-primary" size="sm" id="quick-create">
            + Přidat nové
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {quickCreate.map((item) => (
              <Dropdown.Item
                key={item.id}
                onClick={() => openTab(item.id, item.title, item.path, item.component)}
              >
                <i className={`bi ${item.icon} me-2`} aria-hidden="true"></i>
                {item.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        )}

        {canSettings && (
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => openTab('settings', 'Nastavení', '/settings', 'Settings')}
          >
            Nastavení
          </button>
        )}

        <Dropdown
          align="end"
          show={notifikaceOtevrene}
          onToggle={setNotifikaceOtevrene}
          onMouseEnter={() => setNotifikaceOtevrene(true)}
          onMouseLeave={() => setNotifikaceOtevrene(false)}
        >
          <Dropdown.Toggle as="div" className="notif-bell" role="button" tabIndex={0} title="Notifikace">
            <i className="bi bi-bell" aria-hidden="true" />
            {NOTIFIKACE.length > 0 && <span className="notif-count">{NOTIFIKACE.length}</span>}
          </Dropdown.Toggle>

          <Dropdown.Menu className="notif-menu">
            <div className="notif-header">Notifikace</div>
            {NOTIFIKACE.length === 0 ? (
              <div className="notif-empty">Žádné nové notifikace.</div>
            ) : (
              NOTIFIKACE.map((n) => (
                <div key={n.id} className="notif-item">{n.text}</div>
              ))
            )}
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown align="end">
          <Dropdown.Toggle as="div" className="user-box" style={{ cursor: 'pointer' }}>
            <i className="bi bi-person-circle user-avatar" aria-hidden="true" />
            <span className="d-none d-sm-inline">{displayName}</span>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => openTab('profile', 'Můj profil', '/profile', 'UserProfile')}>
              <i className="bi bi-person me-2" aria-hidden="true"></i>
              Můj profil
            </Dropdown.Item>
            {canSettings && (
              <Dropdown.Item onClick={() => openTab('settings', 'Nastavení', '/settings', 'Settings')}>
                <i className="bi bi-gear me-2" aria-hidden="true"></i>
                Nastavení
              </Dropdown.Item>
            )}
            <Dropdown.Divider />
            <Dropdown.Item className="text-danger" onClick={onLogout}>
              <i className="bi bi-box-arrow-right me-2" aria-hidden="true"></i>
              Odhlásit
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
}

export default Header;
